import { GALLERY_IMAGES, BRAND } from "../data/content";

const SPAN_PATTERN = [
  "lg:row-span-2",
  "",
  "lg:col-span-2",
  "",
  "",
  "lg:row-span-2",
  "lg:col-span-2",
  "",
  "",
  "",
  "lg:col-span-2",
  "",
  "lg:row-span-2",
  "",
  "lg:col-span-2",
  "",
  "",
  "lg:row-span-2",
  "",
  "lg:col-span-2",
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="pt-28">
      <section className="py-20 sm:py-24">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 text-center">
          <span className="text-xs tracking-[0.32em] uppercase text-[#C76D4B]">Gallery</span>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[1]">
            A peek into the <em className="italic text-[#C76D4B]">café.</em>
          </h1>
          <p className="mt-8 text-[#7A5C45] max-w-xl mx-auto">
            Warm lights, slow afternoons, full plates, fuller conversations. Welcome inside Stories.
          </p>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 auto-rows-[200px] sm:auto-rows-[260px] gap-4">
          {GALLERY_IMAGES.map((src, i) => (
            <div
              key={i}
              data-testid={`gallery-img-${i}`}
              className={`relative overflow-hidden rounded-3xl group ${SPAN_PATTERN[i] || ""}`}
            >
              <img
                src={src}
                alt={`Stories café moment ${i + 1}`}
                className="w-full h-full object-cover img-zoom"
              />
              <div className="absolute inset-0 bg-[#2A1E17]/0 group-hover:bg-[#2A1E17]/15 transition-colors"></div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#F3EBE1] py-20">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
          <img src={BRAND.logoBrown} alt="Stories logo" className="mx-auto h-20 w-20" />
          <p className="font-serif-display text-3xl sm:text-4xl italic mt-6">
            "Stories are conversations well millet."
          </p>
          <p className="text-xs tracking-[0.22em] uppercase text-[#7A5C45] mt-6">— the chef</p>
        </div>
      </section>
    </div>
  );
}
